import { i18n } from '@/i18n';

/** HR namespace string with English fallback when i18n is not initialized (e.g. unit tests). */
export function hrT(key: string, fallback: string, options?: Record<string, unknown>): string {
  if (!i18n.isInitialized) return fallback;
  return String(i18n.t(key, { ns: 'hr', defaultValue: fallback, ...options }));
}

export function hrCalTooltip(key: string, fallback: string): string {
  return hrT(`calendar.tooltip.${key}`, fallback);
}

export function hrOvertimeAbbrev(): string {
  return hrT('calendar.legend.overtime', 'OT');
}

export function hrPresentMarker(): string {
  return hrT('calendar.marker.present', 'P');
}

export function hrLeaveMarkerFallback(): string {
  return hrT('calendar.marker.leaveFallback', 'L');
}

export function hrOvertimeMinutesLabel(minutes: string): string {
  return hrT('calendar.overtimeMinutesLabel', `${minutes} OT`, { minutes, abbrev: hrOvertimeAbbrev() });
}

export function hrOvertimeBadgeLabel(statusCode: string): string {
  return hrT('calendar.overtimeBadge', `OT ${statusCode}`, { abbrev: hrOvertimeAbbrev(), status: statusCode });
}
